import React, { FC } from "react"
import { Button, CircularProgress } from "@mui/material"
import { useAuth } from "react-oidc-context"

interface IOIDCLoginButtonProps {
  fullWidth?: boolean
  disabled?: boolean
}

export const OIDCLoginButton: FC<IOIDCLoginButtonProps> = ({
  fullWidth = true,
  disabled = false,
}) => {
  const auth = useAuth()

  const handleKeycloakLogin = async () => {
    try {
      await auth.signinRedirect()
    } catch (error) {
      console.error("Error during Keycloak login:", error)
    }
  }

  const isLoading = auth.isLoading || auth.activeNavigator === "signinRedirect"

  return (
    <Button
      variant="outlined"
      fullWidth={fullWidth}
      disabled={disabled || isLoading}
      onClick={handleKeycloakLogin}
      color="secondary"
    >
      Войти через Keycloak&nbsp;
      {isLoading && <CircularProgress size={20} />}
    </Button>
  )
}
